/**
 * As três abas da administração: Notebooks, Pessoas e Auditoria.
 *
 * Elas vivem juntas porque respondem a perguntas do mesmo tipo, e todas as três só aparecem
 * para quem cuida do cadastro de todo o Campo. Quem abre uma delas quase sempre vai abrir
 * outra em seguida: "o notebook está mandando?" vira "quem cortou ele, e quando?".
 */
import type { JSX } from 'react'
import { irPara } from '../rotas'

const ABAS = [
  { endereco: '/notebooks', titulo: 'Notebooks' },
  { endereco: '/pessoas', titulo: 'Pessoas' },
  { endereco: '/auditoria', titulo: 'Auditoria' }
] as const

export function AbasDaAdministracao({ aquiEstou }: { aquiEstou: string }): JSX.Element {
  return (
    <nav className="abas so-tela">
      {ABAS.map((aba) => (
        <button
          key={aba.endereco}
          className={aba.endereco === aquiEstou ? 'aba aqui' : 'aba'}
          aria-current={aba.endereco === aquiEstou ? 'page' : undefined}
          onClick={() => irPara(aba.endereco)}
        >
          {aba.titulo}
        </button>
      ))}
    </nav>
  )
}
